import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { ShFormFourStateCheckboxComponent } from '../../../../../form-controls/components/form-four-state-checkbox/main/form-four-state-checkbox.component';
import { BatchFieldReadHelper } from '../../../../helpers/fields/batch-field-read.helper';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSimpleInputFieldComponent } from '../simple-input-field/simple-input-field.component';

@Component({
    standalone: true,
    selector: 'sh-boolean-field',
    templateUrl: './boolean-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShFormFourStateCheckboxComponent, CommonModule, TranslateModule]
})
export class ShBooleanInputFieldComponent extends ShSimpleInputFieldComponent {
    constructor(protected fieldHelper: FieldReadHelper) {
        super(fieldHelper);
    }

    init(profileField: ExtendedBaseProfileField, records: PartialRecord[], control: UntypedFormControl): void {
        const value = this.isBatchEdit
            ? BatchFieldReadHelper.getBatchFieldValue(profileField.FieldDefinition)
            : this.fieldHelper.getMergedBooleanFieldValue(profileField.FieldDefinition, records);
        control.setValue(value);
    }
}
